import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, resolveComponent as _resolveComponent, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-67ccadab"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = ["data-cy"]
const _hoisted_3 = ["id", "data-cy", "data-question-name", "placeholder", "disabled"]
const _hoisted_4 = {
  key: 0,
  class: "tw-h-[38px] tw-w-[38px] tw-justify-end tw-right-[25px] tw-flex tw-items-center"
}
const _hoisted_5 = {
  key: 1,
  class: "tw-h-[38px] tw-w-[38px] tw-justify-end tw-right-[25px] tw-flex tw-items-center"
}
const _hoisted_6 = {
  key: 2,
  class: "tw-h-[38px] tw-w-[38px] tw-justify-end tw-right-[25px] tw-flex tw-items-center"
}

import { getComponentUiText } from "@/utils/utilities";
import { computed, onMounted, ref, watch } from "vue";
import DraggableIcon from "@/components/svgs/draggableIcon.vue";
import { useVuelidate } from "@vuelidate/core";
import { helpers, required } from "@vuelidate/validators";
import CustomCheckbox from "../common/customCheckBox.vue";
import VRuntimeTemplate from "vue3-runtime-template";
import ButtonShowMore from "../common/setting/buttonShowMore.vue";
import CustomDropDownItem from "../common/customDropDownItem.vue";
import { updateChecklistRequestedTemplateItem } from "@/services/vendor";
import store from "@/store";
import { Vendor } from "@/services/apiRoutes/routes";
import { showErrorAPI } from "@/services/apiRoutes";
import { LottieAnimation } from "lottie-web-vue";
import ProgressAnimation from "../../assets/animation/progress_light.json";
import SuccessAnimation from "../../assets/animation/success.json";
import ErrorAnimation from "../../assets/animation/error.json";
import { VENDOR_TEMPLATE_API_STATUS } from "@/utils/constants";

export default /*#__PURE__*/_defineComponent({
  __name: 'vendorAssessmentQuestionHeading',
  props: {
  item: {
    type: Object,
    required: true,
  },
  title: {
    type: String,
    required: false,
    default: "",
  },
  index: {
    type: Number,
    required: true,
  },
  level: {
    type: Number,
    default: 0,
  },
  templateId: {
    type: [String, Number, null],
    required: true,
  },
  isSelected: {
    type: Boolean,
    required: false,
    default: false,
  },
},
  emits: [
  "changeExpand",
  "removeStep",
  "handleUpdateData",
  "handle-select-item",
],
  setup(__props, { expose: __expose, emit: emits }) {

const props = __props;

_useCssVars(_ctx => ({
  "2452d549": (margin.value)
}))


const isFocus = ref(false);
const isCallAPI = ref(false);
const heading = ref(
  props.item.itemMasterHeadingLabel || props.item.itemMasterName || "",
);

const isSuccess = ref(false);
const isFail = ref(false);

const currentValue = ref("");

const margin = computed(() => {
  return `${props.level * 25}px`;
});

const handleUpdateAssessmentQuestionName = async (val) => {
  if (props.item.itemMasterId) {
    await v$.value.$validate();
    if (v$.value.$error) return;
    try {
      isCallAPI.value = true;
      await updateChecklistRequestedTemplateItem({
        templateId: props.templateId,
        params: {
          itemMasterId: props.item.itemMasterId,
          isHeading: true,
          headingLabel: val,
          name: val,
        },
      });
      isSuccess.value = true;
      setTimeout(() => {
        isSuccess.value = false;
      }, 2000);
    } catch (error) {
      isFail.value = true;
      setTimeout(() => {
        isFail.value = false;
      }, 1500);
      form.value.heading = currentValue.value;
      showErrorAPI(error, Vendor.putChecklistRequestedTemplateItem);
    } finally {
      isCallAPI.value = false;
    }
  }
};


const handleUpdateData = (text) => {
  heading.value = text;
  emits("handleUpdateData", heading.value, props.index);
};
const rules = {
  heading: {
    required: helpers.withMessage(
      () => getComponentUiText("app-setting-org-detail-required-fields-1"),
      required,
    ),
  },
};

const form = ref({
  heading: heading.value,
});

const statusCallAPIPOST = computed(() => {
  const addTemplateItemStatus = store.state.Vendor.addTemplateItemStatus;
  return addTemplateItemStatus.find((x) => x.id === props.item?.id);
});

watch(statusCallAPIPOST, (value) => {
  if (value?.loading === VENDOR_TEMPLATE_API_STATUS.isloading) {
    isCallAPI.value = true;
  } else {
    isCallAPI.value = false;
  }
  if (value?.loading === VENDOR_TEMPLATE_API_STATUS.suceess) {
    isSuccess.value = true;
    setTimeout(() => {
      isSuccess.value = false;
      store.dispatch("Vendor/setAddTemplateItemStatus", {
        id: props.item.id,
        loading: VENDOR_TEMPLATE_API_STATUS.remove,
      });
    }, 2000);
  }
  if (value?.loading === VENDOR_TEMPLATE_API_STATUS.error) {
    isFail.value = true;
    setTimeout(() => {
      isFail.value = false;
      store.dispatch("Vendor/setAddTemplateItemStatus", {
        id: props.item.id,
        loading: VENDOR_TEMPLATE_API_STATUS.remove,
      });
    }, 1500);
  }
});

const v$ = useVuelidate(rules, form as any);

onMounted(() => {
  if (
    statusCallAPIPOST.value?.loading === VENDOR_TEMPLATE_API_STATUS.isloading
  ) {
    isCallAPI.value = true;
  } else {
    isCallAPI.value = false;
  }
  if (statusCallAPIPOST.value?.loading === VENDOR_TEMPLATE_API_STATUS.suceess) {
    isSuccess.value = true;
    setTimeout(() => {
      isSuccess.value = false;
      store.dispatch("Vendor/setAddTemplateItemStatus", {
        id: props.item.id,
        loading: VENDOR_TEMPLATE_API_STATUS.remove,
      });
    }, 2000);
  }
  if (statusCallAPIPOST.value?.loading === VENDOR_TEMPLATE_API_STATUS.error) {
    isFail.value = true;
    setTimeout(() => {
      store.dispatch("Vendor/setAddTemplateItemStatus", {
        id: props.item.id,
        loading: VENDOR_TEMPLATE_API_STATUS.remove,
      });
      isFail.value = false;
    }, 1500);
  }
  document.getElementById(`input-vendor-question-${props.index}`)?.focus();
});

const saveChanges = async () => {
  await v$.value.$validate();
  // true is not error
  return !v$.value.$error;
};
__expose({
  saveChanges,
});

return (_ctx: any,_cache: any) => {
  const _component_b_form_invalid_feedback = _resolveComponent("b-form-invalid-feedback")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createElementBlock("div", {
      id: `vendor-assessment-question-heading-${__props.index}`,
      key: __props.index,
      class: _normalizeClass(`tw-flex tw-flex-row tw-overflow-hidden tw-items-center tw-font-[Poppins] tw-pr-[25px] assessment-heading-container`)
    }, [
      _createElementVNode("span", {
        class: "tw-cursor-pointer drag-handle tw-pl-[15px] tw-pr-[5px] tw-flex tw-items-center tw-py-[15px]",
        "data-cy": `drag-handle-${__props.index}`
      }, [
        _createVNode(DraggableIcon, {
          width: 8,
          height: 12
        })
      ], 8, _hoisted_2),
      _createVNode(CustomCheckbox, {
        class: _normalizeClass(`!tw-h-[20px] !tw-mb-0 !tw-pl-0 tw-ml-[5px] tw-mr-[15px]`),
        size: "20px",
        "is-checked": __props.isSelected,
        "onUpdate:isChecked": _cache[0] || (_cache[0] = 
        (value) => {
          emits('handle-select-item', value, __props.index);
        }
      )
      }, null, 8, ["is-checked"]),
      _withDirectives(_createElementVNode("input", {
        id: `input-vendor-question-${__props.index}`,
        "onUpdate:modelValue": [
          _cache[1] || (_cache[1] = ($event: any) => ((form.value.heading) = $event)),
          _cache[5] || (_cache[5] = 
        (text) => {
          heading.value = text;
          form.value.heading = text;
          handleUpdateData(text);
        }
      )
        ],
        "data-cy": `input-heading-name-${__props.index}`,
        "data-question-name": `${form.value.heading}`,
        class: _normalizeClass(`tw-relative tw-w-full tw-mr-[15px] tw-placeholder-[#B7B7B7] tw-ml-[15px] tw-text-[18px] tw-font-semibold tw-font-[Poppins] tw-text-[#211F58] input-detail-question`),
        placeholder: 
        _unref(getComponentUiText)(
          'app-assessment-assessment-vendor-assessment-heading-placeholder-1',
        )
      ,
        disabled: __props.item.itemMasterId === -1,
        style: {"border":"unset","background-color":"unset"},
        onBlur: _cache[2] || (_cache[2] = ($event: any) => (isFocus.value = false)),
        onFocus: _cache[3] || (_cache[3] = 
        (val) => {
          currentValue.value = val.target.value;
          isFocus.value = true;
        }
      ),
        onFocusout: _cache[4] || (_cache[4] = 
        (val) => {
          if (currentValue.value !== val.target.value) {
            handleUpdateAssessmentQuestionName(val.target.value);
          }
        }
      )
      }, null, 40, _hoisted_3), [
        [_vModelText, form.value.heading]
      ]),
      (isCallAPI.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_unref(LottieAnimation), {
              ref: "anim",
              "animation-data": _unref(ProgressAnimation),
              "auto-play": true,
              loop: true
            }, null, 8, ["animation-data"])
          ]))
        : _createCommentVNode("", true),
      (isSuccess.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_unref(LottieAnimation), {
              ref: "anim",
              "animation-data": _unref(SuccessAnimation),
              "auto-play": true,
              loop: true
            }, null, 8, ["animation-data"])
          ]))
        : _createCommentVNode("", true),
      (isFail.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_unref(LottieAnimation), {
              ref: "anim",
              "animation-data": _unref(ErrorAnimation),
              "auto-play": true,
              loop: true
            }, null, 8, ["animation-data"])
          ]))
        : _createCommentVNode("", true),
      (__props.item.itemMasterId !== -1)
        ? (_openBlock(), _createBlock(ButtonShowMore, {
            key: 3,
            "id-popover": `popover-vendor-assessment-heading-${__props.index}${
        __props.item.itemMasterId ?? Math.random()
      }`,
            "is-from-notification": true,
            "data-cy-id": `popover-vendor-assessment-question-${__props.index}`,
            "data-question-id": `${__props.item.itemMasterId}`
          }, {
            default: _withCtx(() => [
              (__props.item?.itemMasterId !== -1)
                ? (_openBlock(), _createBlock(CustomDropDownItem, {
                    key: 0,
                    style: 'danger',
                    "id-text": 'app-assessment-vendor-delete-heading-title-1',
                    "style-text": '!tw-self-auto',
                    "data-cy": "remove-question-menu",
                    "id-item": `popover-vendor-assessment-heading-item-${__props.index}-${
          __props.item.itemMasterId ?? Math.random()
        }`,
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (emits('removeStep', __props.index)))
                  }, null, 8, ["id-item"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["id-popover", "data-cy-id", "data-question-id"]))
        : _createCommentVNode("", true)
    ], 8, _hoisted_1)),
    (_unref(v$).heading.$error)
      ? (_openBlock(), _createBlock(_component_b_form_invalid_feedback, {
          key: 0,
          class: _normalizeClass('is-invalid')
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(VRuntimeTemplate), {
              template: _unref(v$).heading?.$errors?.[0]?.$message
            }, null, 8, ["template"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})